import React from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { map } from "lodash";
import "./TableOffersAdmin.scss";

export function TableOffersAdmin(props) {
  const { offers, updateOffer, deleteOffer } = props;

  return (
    <Table className="table-offers-admin">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Oferta</Table.HeaderCell>
          <Table.HeaderCell>Categoria</Table.HeaderCell>
          <Table.HeaderCell>Incluye</Table.HeaderCell>
          <Table.HeaderCell>Precio</Table.HeaderCell>
          <Table.HeaderCell>Activa</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(offers, (offer) => (
          <Table.Row key={offer.id}>
            <Table.Cell>{offer.title}</Table.Cell>
            <Table.Cell>{offer.category_data?.title}</Table.Cell>
            <Table.Cell>
              {map(offer.products_data, (product) => product.title).join(
                ", "
              )}
            </Table.Cell>
            <Table.Cell>S/ {offer.price}</Table.Cell>
            <Table.Cell className="status">
              {offer.active ? <Icon name="check" /> : <Icon name="close" />}
            </Table.Cell>

            <Table.Cell textAlign="right">
              <Button icon onClick={() => updateOffer(offer)}>
                <Icon name="pencil" />
              </Button>
              <Button icon negative onClick={() => deleteOffer(offer)}>
                <Icon name="close" />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}
